export default __webpack_public_path__ + "d1b2062235fe0d3de9aa27cbeb55c86f.png";